export function csvGetHeaders(file) {
  return new Promise((resolve, reject) => {
    try {
      const reader = new window.FileReader();

      let res = '';

      reader.onload = (evt) => {
        // Get the Array Buffer.
        const data = evt.target.result;

        const { byteLength } = data;

        // Convert to conventional array, so we can iterate though it.
        const ui8a = new Uint8Array(data, 0);

        // Used to store each character that makes up CSV header.
        let headerString = '';

        for (let i = 0; i < byteLength; i += 1) {
          // Get the character for the current iteration.
          const char = String.fromCharCode(ui8a[i]);

          // Check if the char is a new line.
          if (char.match(/[^\r\n]+/g) !== null) {
            headerString += char;
          } else {
            break;
          }
        }

        res = headerString.split(',');

        return resolve(res);
      };

      // Read our file to an ArrayBuffer
      reader.readAsArrayBuffer(file);
    } catch (e) {
      return reject(e);
    }
  });
}

export function compare(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b)) {
    return false;
  }

  for (let i = 0; i < a.length; i += 1) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

// export function CSVGetHeaders(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new window.FileReader();
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = reject;
//     reader.readAsText(file);
//   });
// }

// export function CSVGetHeaders(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new window.FileReader();
//     reader.onload = (e) => {
//       const text = reader.result;
//
//       const firstLine = text.split('\n').shift(); // first line
//
//       return resolve(firstLine);
//     };
//     reader.onerror = reject;
//     reader.readAsText(file);
//   });
// }
